import { render, staticRenderFns } from "./ScratchOff.vue?vue&type=template&id=09bf13fc"
import script from "./ScratchOff.vue?vue&type=script&lang=js"
export * from "./ScratchOff.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports